module.exports = __webpack_public_path__ + "img/loading.1369818e.gif";